import { Link } from 'react-router-dom';
import type { Topic } from '@/mocks/topics';

type Props = {
  topic: Topic;
  index?: number;
};

export default function TopicCard({ topic, index }: Props) {
  const isFeature = typeof index === 'number' && index === 0;

  return (
    <article
      className={`group bg-background-100 border border-background-200 rounded-lg overflow-hidden flex flex-col ${
        isFeature ? 'lg:flex-row lg:col-span-2' : ''
      }`}
    >
      <Link
        to={`/topic/${topic.slug}`}
        className={`block relative overflow-hidden shrink-0 cursor-pointer ${
          isFeature ? 'h-56 lg:h-auto lg:w-1/2' : 'h-48'
        }`}
      >
        <img
          src={topic.cover}
          alt={`${topic.title} - ${topic.categoryName}专题封面`}
          title={`${topic.title} 专题合集`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-[11px] font-medium bg-background-50/95 text-primary-700 backdrop-blur">
          {topic.categoryName}
        </span>
        <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md text-[11px] bg-foreground-950/70 text-background-50 backdrop-blur">
          {topic.status}
        </span>
      </Link>

      <div className={`p-5 flex flex-col ${isFeature ? 'lg:p-8 lg:w-1/2 lg:justify-center' : ''}`}>
        <div className="flex items-center gap-3 text-[11px] text-foreground-500 mb-3">
          <span className="flex items-center gap-1">
            <i className="ri-stack-line"></i>
            {topic.count} 条
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {topic.updated}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-book-read-line"></i>
            约 {topic.readMins} 分钟
          </span>
        </div>

        <h3
          className={`font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors ${
            isFeature ? 'text-xl md:text-3xl leading-snug' : 'text-lg leading-snug'
          }`}
        >
          <Link to={`/topic/${topic.slug}`} className="cursor-pointer">
            {topic.title}
          </Link>
        </h3>

        <p className={`mt-3 text-sm leading-relaxed text-foreground-600 ${isFeature ? 'line-clamp-3' : 'line-clamp-2'}`}>
          {topic.summary}
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          {topic.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2.5 py-1 rounded-full text-[11px] bg-secondary-100 text-secondary-900">
              #{tag}
            </span>
          ))}
        </div>

        <Link
          to={`/topic/${topic.slug}`}
          className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer w-fit"
        >
          查看合集
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </Link>
      </div>
    </article>
  );
}